import React from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom';

const DummyDashboard = () => {
    let { id } = useParams();
    return id && <Navigate to={"/"} state={id} />
}

export default DummyDashboard
